import { render, staticRenderFns } from "./ManageLoanItem.vue?vue&type=template&id=e6cb1788"
import script from "./ManageLoanItem.vue?vue&type=script&lang=js"
export * from "./ManageLoanItem.vue?vue&type=script&lang=js"
import style0 from "./ManageLoanItem.vue?vue&type=style&index=0&id=e6cb1788&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports